import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { dynamicFontSize, fontFamilyHeading, fontFamilyBody } from '../styles/helpers/mixins';

const ProductSplashCard = props => {
  if (!props.images || !props.body || !props.title) return false;

  return (
    <ProductSplash image={SITE_ROOT_URL + props.images.getIn(['url'])}>
      <ProductSplashOverlay>
        <ProductSplashHeading>{props.title}</ProductSplashHeading>
        <ProductSplashPreamble>{props.body}</ProductSplashPreamble>
        <ProductSplashLink href={props.link}>Läs vidare</ProductSplashLink>
      </ProductSplashOverlay>
    </ProductSplash>
  );
};

const ProductSplash = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 300px;
  background-color: #43636d;
  background-image: url("${props => props.image}");
`;
const ProductSplashOverlay = styled.div`
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const ProductSplashHeading = styled.p`
  ${fontFamilyHeading}; 
  ${dynamicFontSize(22, 34)};
  text-align: center;
  margin-top: 0;
  margin-bottom: 25px;
  line-height: 1.25;
  color: #ffffff;
`;
const ProductSplashLink = styled.a`
  ${fontFamilyBody};
  ${dynamicFontSize(10, 13)};
  font-weight: 600;
  letter-spacing: 2.5px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  &:after {
    content: '';
    display: block;
    background-image: url('/images/icons/arrow-white.svg');
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 10px;
    height: 10px;
    justify-self: flex-end;
    transform: rotate(-90deg);
    margin-left: 10px;
  }
`;

const ProductSplashPreamble = styled.span`
  display: none;
  @media screen and (min-width: 1140px) {
    ${fontFamilyBody};
    text-align: center;
    font-size: 18px;
    font-style: italic;
    line-height: 1.56;
    color: #ffffff;
    display: block;
    margin-bottom: 50px;
  }
`;

ProductSplashCard.defaultProps = {
  title: null,
  body: null,
  link: null,
  images: Map()
};

ProductSplashCard.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  link: PropTypes.string,
  images: PropTypes.instanceOf(Map())
};

export default ProductSplashCard;



// WEBPACK FOOTER //
// ./src/components/ProductSplashCard.js